import React from "react";
import { useTheme } from "../context/ThemeContext";
import { useAuthStore } from "../store/useAuthStore";
import api from "../lib/api";
import SunIcon from "@/assets/components/sun.svg?react";
import MoonIcon from "@/assets/components/moon.svg?react";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const authSetTheme = useAuthStore((state) => state.setTheme);
  const authSetUser = useAuthStore((state) => state.setUser);
  const user = useAuthStore((state) => state.user);

  const toggleTheme = async () => {
    const newTheme = theme === "light" ? "dark" : "light";

    try {
      // Call backend API to toggle theme
      const response = await api.post("/auth/me/toggle-theme");
      const { themePreference } = response.data.data;

      // Update local state
      setTheme(themePreference);

      // Update auth store
      authSetTheme(themePreference);

      // Update user object in auth store
      if (user) {
        authSetUser({ ...user, themePreference });
      }
    } catch (error) {
      console.error("Failed to toggle theme:", error);
      // Fallback to local toggle if API fails
      setTheme(newTheme);
      authSetTheme(newTheme);
    }
  };

  return (
    <div className="relative flex items-center w-16 overflow-hidden border-0 rounded-full shadow-sm h-7 md:w-24 md:h-8">
      {/* Sliding background indicator */}
      <div
        className={`absolute top-0 w-1/2 h-full ${
          theme === "light"
            ? "translate-x-0 bg-[#EEEBF4]"
            : "translate-x-full bg-[#2c213d]"
        }`}
      />

      {/* Sun icon - Light mode */}
      <div
        onClick={() => theme === "dark" && toggleTheme()}
        className={`relative z-10 w-1/2 h-full flex items-center justify-center cursor-pointer ${
          theme === "light"
            ? "scale-110"
            : "bg-primary-shade-3 scale-100 hover:scale-105"
        }`}
      >
        <SunIcon
          className={`size-4 ${
            theme === "dark" ? "text-white" : "text-[#552e8e]"
          }`}
        />
      </div>

      {/* Moon icon - Dark mode */}
      <div
        onClick={() => theme === "light" && toggleTheme()}
        className={`relative z-10 w-1/2 h-full flex items-center justify-center cursor-pointer ${
          theme === "dark" ? "scale-110" : "scale-100 hover:scale-105"
        }`}
      >
        <MoonIcon
          className={`size-4 ${
            theme === "light" ? "text-black" : "text-nav-highlight"
          }`}
        />
      </div>
    </div>
  );
}
